import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth, db } from '../firebaseConfig/firebase';
import { getDocs, collection, query, where } from "firebase/firestore";
import { Spinner, Container } from 'react-bootstrap';

// Componentes
import Hometribu from './Hometribu';
import HomeAlumno from './HomeAlumno';
import Login from './Login';

const Home = () => {
    const navigate = useNavigate();
    const [userEmail, setUserEmail] = useState();
    const [isTribunal, setIsTribunal] = useState(false);
    const [checkingRole, setCheckingRole] = useState(true);

    // 1. Estados más claros
    // null = cargando, true = autenticado, false = no autenticado
    const [isAuthenticated, setIsAuthenticated] = useState(null);

    useEffect(() => {
        // 2. Limpieza del suscriptor (cleanup function)
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                console.log("Usuario autenticado:", user.uid);
                console.log(user);
                setUserEmail(user.email);
                setIsAuthenticated(true);
            } else {
                console.log("Usuario no autenticado");
                setIsAuthenticated(false);
            }
        });

        // Retornar la función de limpieza para evitar fugas de memoria
        return () => unsubscribe();
    }, []);

    useEffect(() => {
        const checkUserRole = async () => {
            if (isAuthenticated && userEmail) {
                setCheckingRole(true);
                try {
                    // Consultamos si el email existe en tribu-equipo
                    const q = query(
                        collection(db, "tribu-equipo"),
                        where("EMAIL", "==", userEmail.toLowerCase().trim())
                    );
                    const querySnapshot = await getDocs(q);

                    // Si la consulta tiene resultados, es tribunal
                    setIsTribunal(!querySnapshot.empty);
                } catch (error) {
                    console.error("Error verificando rol:", error);
                    setIsTribunal(false);
                } finally {
                    setCheckingRole(false);
                }
            } else {
                setCheckingRole(false);
            }
        };

        checkUserRole();
    }, [isAuthenticated, userEmail]);

    const handleLogout = async () => {
        try {
            await signOut(auth);
            console.log("Cierre de sesión exitoso");
            navigate("/Login");
        } catch (error) {
            console.error("Error al cerrar sesión:", error);
        }
    };

    if (!isAuthenticated) {
        return <Login />;
    }

    if (checkingRole) {
        // Puedes poner un spinner de carga mientras verifica el email
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <Spinner animation="border" variant="primary" />
            </div>
        );
    }

    // Si está autenticado y ya verificamos el rol:
    return isTribunal ? (
        <Hometribu handleLogout={handleLogout} email={userEmail} />
    ) : (
        <HomeAlumno handleLogout={handleLogout} email={userEmail} />
    );
};

export default Home;